import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../../networking/client';
import { RootState } from '../store';
import { toast } from 'react-toastify';

export type IWorkingHours = {
  end_time: string;
  start_time: string;
  weekday_id: number;
};
export interface calendarAndSlotsState {
  status: string;
  updateStatus: string;
  workingHoursStatus: string;
  calendarAndSlots: any[];
  workingHours: IWorkingHours[];
}

const initialState: calendarAndSlotsState = {
  status: 'idle',
  updateStatus: 'idle',
  workingHoursStatus: 'idle',
  calendarAndSlots: [],
  workingHours: [],
};

export const fetchCalendarAndSlots = createAsyncThunk(
  'calendarAndSlots/fetchAll',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const getMerchantCalendarResponse: any = await client.get(`/core/merchant/calendar`);
      return getMerchantCalendarResponse;
    } catch (err: any) {
      return rejectWithValue(err?.response?.data ?? {});
    }
  }
);
export const fetchWorkingHours = createAsyncThunk(
  'workingHours/fetchAll',
  async (_, { dispatch, rejectWithValue, getState }) => {
    try {
      const state: any = getState();
      const getMerchantCalendarResponse: any = await client.get(
        `/core/merchant/${state.auth.accountInfo.external_person_id}/opencalendar`,
        {
          headers: {
            Authorization: `Basic ${state?.auth?.basicAuth}`,
          },
        }
      );
      return getMerchantCalendarResponse;
    } catch (err: any) {
      return rejectWithValue(err?.response?.data ?? {});
    }
  }
);

export const updateCalendarAndSlots = createAsyncThunk(
  'calendarAndSlots/updateAll',
  async (data: any, { dispatch, rejectWithValue, getState }) => {
    try {
      const state: any = getState();
      const createWorkServiceResponse: any = await client.put(
        `/healthpoint/put-merchant-calendar/${state?.auth?.basicAuth}`,
        {
          calendar: {
            timeslot_length: data.timeslot_length,
            calendar_items: data.calendar_items,
            capacity_per_timeslot: data.capacity_per_timeslot,
            excludes: data.excludes,
            date_range_days: data.date_range_days,
            exceptional_openings: data.exceptional_openings,
          },
        }
      );
      return createWorkServiceResponse;
    } catch (err: any) {
      return rejectWithValue(err?.response?.data ?? {});
    }
  }
);
export const updateWorkingHours = createAsyncThunk(
  'calendarAndSlots/updateAll',
  async (data: any, { dispatch, rejectWithValue, getState }) => {
    try {
      const state: any = getState();
      const createWorkServiceResponse: any = await client.put(
        `/core/merchant/${state.auth.accountInfo.external_person_id}/opencalendar`,
        data,

        {
          headers: {
            Authorization: `Basic  ${state?.auth?.basicAuth}`,
          },
        }
      );
      return createWorkServiceResponse;
    } catch (err: any) {
      return rejectWithValue(err?.response?.data ?? {});
    }
  }
);

export const calendarAndSlotsSlice = createSlice({
  name: 'calendarAndSlots',
  initialState,
  reducers: {
    resetcalendarAndSlots: (_) => {
      return initialState;
    },
    updateCalendarAndSlotsState: (state, action) => {
      return {
        ...initialState,
        calendarAndSlots: action.payload,
      };
    },
    updateWorkingHoursState: (state, action) => {
      return {
        ...initialState,
        workingHours: action.payload,
      };
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchCalendarAndSlots.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(fetchCalendarAndSlots.fulfilled, (state, action) => {
        state.calendarAndSlots = action.payload.data;
        state.status = 'fulfilled';
      })
      .addCase(fetchCalendarAndSlots.rejected, (state, action: any) => {
        toast.error(action?.payload?.error ?? 'Something went wrong.', {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        state.status = 'rejected';
      })
      .addCase(fetchWorkingHours.pending, (state) => {
        state.workingHoursStatus = 'pending';
      })
      .addCase(fetchWorkingHours.fulfilled, (state, action) => {
        state.workingHours = action.payload.data;
        state.workingHoursStatus = 'fulfilled';
      })
      .addCase(fetchWorkingHours.rejected, (state, action: any) => {
        toast.error(action?.payload?.error ?? 'Something went wrong.', {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        state.workingHoursStatus = 'rejected';
      })
      .addCase(updateCalendarAndSlots.pending, (state) => {
        state.updateStatus = 'pending';
      })
      .addCase(updateCalendarAndSlots.fulfilled, (state, action) => {
        state.updateStatus = 'fulfilled';
        toast.success('Successfully updated Calendar & Slots', {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      })
      .addCase(updateCalendarAndSlots.rejected, (state, action: any) => {
        toast.error(action?.payload?.error ?? 'Something went wrong.', {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        state.updateStatus = 'rejected';
      });
  },
});

export const { resetcalendarAndSlots, updateCalendarAndSlotsState, updateWorkingHoursState } =
  calendarAndSlotsSlice.actions;

export default calendarAndSlotsSlice.reducer;

export const selectCalendarAndSlots = (state: RootState) => state.calendarAndSlots.calendarAndSlots;
export const selectWorkingHours = (state: RootState) => state.calendarAndSlots.workingHours;
export const selectCalendarAndSlotsStatus = (state: RootState) => state.calendarAndSlots.status;
